import { Deserializable } from '../../protocols/deserializable';
import { UniquelyIdentifiable } from '../../protocols/uniquely-identifiable';

/**
 * One variant's place inside an insight collection's results.
 *
 * Carries no product detail at all - name, brand and image are resolved against
 * `ProductDomainModel.currentLocationVariantLookup$`, so a variant the current location does not carry has nothing
 * to render and is dropped by the view model.
 */
export class HighGuideInsightCollectionProduct implements Deserializable, UniquelyIdentifiable {
  /** Ascending layout order, computed server side. The client sorts on this and never on the scores below. */
  public order: number;
  public variantId: string;
  public score: number;
  public signalScore: number;
  public matchedSignalCount: number;
  public signalCount: number;

  onDeserialize(): void {}

  getUniqueIdentifier(): string {
    return `${this.variantId}-${this.order}-${this.score}`;
  }
}
